/**
 * Intercepts CoralRequests, produces observable CoralResponses. Typically this will
 * involve passing execution to the handler, which will produce the response.
 *
 * Based on Angular's HttpInterceptor interface. While this class is fully
 * framework-agnostic, the Angular documenation may be useful for understanding
 * how interceptors are used.
 */
export class CoralInterceptor {
}
